import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => {
    const smallMobileBreakpoint = getThemeBreakpointByDeviceType(theme, EDeviceType.SMALL_MOBILE);

    return {
        productLine: {
            backgroundColor: theme.palette.background.dark,
            color: theme.palette.secondary.main,
            transition: theme.transitions.create("border-radius", {
                duration: theme.transitions.duration.standard,
                easing: theme.transitions.easing.easeInOut,
            }),
        },
        eSimContainer: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        roundedBottom: {
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius,
        },
        roundedTop: {
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
        },
        switchContainer: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
        },
        divider: {
            borderColor: theme.palette.primary.contrastText,
            marginInline: theme.spacing(2),
            // prevent divider from being in the accordion
            marginTop: "-1px",
        },
        checkedDetails: {
            [smallMobileBreakpoint]: {
                padding: "0 !important",
            },
        },
        checkedDetailsDesktop: {
            flexGrow: 1,
            marginLeft: theme.spacing(4),
        },
        deleteButton: {
            [smallMobileBreakpoint]: {
                padding: theme.spacing(1.5),
            },
        },
        iconButton: {
            padding: theme.spacing(1.25),
        },
        switch: {
            justifyContent: "flex-start",
            [smallMobileBreakpoint]: {
                justifyContent: "space-between",
            },
        },
        switchLabel: {
            "& > p": {
                marginRight: theme.spacing(1),
            },
            [smallMobileBreakpoint]: {
                "& > p": {
                    marginRight: theme.spacing(0),
                },
            },
        },
        switchCheckbox: {
            justifyContent: "flex-start",
            gap: theme.spacing(1),
            [smallMobileBreakpoint]: {
                justifyItems: "end",
            },
        },
        edit: {
            border: `${theme.palette.primary.contrastText} 1px solid !important`,
        },
        extraComponent: {
            marginBottom: theme.spacing(2),
        },
        getESimDescription: {
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: theme.spacing(0.5),
        },
    };
});
